<div>
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="notApprovedSpecialistsByTopic()"></grid-content>
</div>